import "./Common/Menu.api";
export { MenuDesktop } from "./Desktop/MenuDesktop.container";
export { MenuMobile } from "./Mobile/MenuMobile.container";

export type MenuActions =
  | "menu.tab.set"
  | "gamesettings.toggled"
  | "gamerules.toggled"
  | "gamerules.content.set"
  | "gamehistory.toggled"
  | "setting.changerequest";
